import React, { useState } from "react";
import { Box, Button, Popover, Stack, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
	anchorEl: HTMLElement | null;
	open: boolean;

	title: string;
	label?: string;

	initialValue?: string;

	validateName?: (name: string) => boolean;

	onClose: () => void;
	onSave: (name: string) => void;
};

export const FilterNamePopover: React.FC<Props> = ({
	anchorEl,
	open,
	title,
	label,
	initialValue = "",
	onClose,
	onSave,
	validateName,
}) => {
	const { t } = useTranslation("common");
	const [name, setName] = useState("");

	const isNameAvailable = validateName ? validateName(name) : true;

	const handleClose = () => {
		onClose();
		setName("");
	};

	const handleSave = () => {
		onSave(name.trim());
		handleClose();
	};

	return (
		<Popover
			open={open}
			anchorEl={anchorEl}
			onClose={handleClose}
			anchorOrigin={{
				vertical: "bottom",
				horizontal: "left",
			}}
			transformOrigin={{
				vertical: "top",
				horizontal: "left",
			}}
		>
			<Stack width="260px" p={2} spacing={2}>
				<Typography variant="subtitle2">{title}</Typography>

				<Box position={"relative"} pb={0.5}>
					<TextField
						autoFocus
						fullWidth
						size="small"
						label={label}
						value={name}
						placeholder={initialValue}
						onChange={(e) => setName(e.target.value)}
					/>
					{!isNameAvailable && name.length > 0 && (
						<Typography
							variant="caption"
							color="error"
							position={"absolute"}
							bottom={"-1.5em"}
							left={".2em"}
						>
							{t("invalid filter name")}
						</Typography>
					)}
				</Box>

				<Stack direction="row" spacing={2} justifyContent="flex-end">
					<Button size="small" onClick={handleClose}>
						{t("cancel")}
					</Button>

					<Button
						variant="contained"
						size="small"
						onClick={handleSave}
						disabled={!name.trim() || !isNameAvailable}
					>
						{t("save")}
					</Button>
				</Stack>
			</Stack>
		</Popover>
	);
};
